import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { Card, Statistic, Button, Tooltip, Tag, Row,Col } from 'antd';
import { AuditOutlined } from '@ant-design/icons';

class LabDetailsSummary extends Component {

    constructor(props) {
        super(props);
        this.store = props.store;
    }

    generateInvoice = async () => {
        await this.store.generateInvoice();
    }

    renderInvoiceButton = () => {

        if (!this.store.canGenerate) {
            return (
                <Tag color="red">No Pending Transactions.</Tag>
            )
        }

        if (this.store.canGenerate && !this.store.isLoading) {
            return (
                <Tooltip title="Generate Invoices for each of the distinct buckets">
                    <Button onClick={() => this.generateInvoice()} shape="round" style={{ background: "rgb(27,160,97)", color: "white" }} disabled={this.store.isLoading} icon={<AuditOutlined />}>Generate Invoice</Button>
                </Tooltip>
            )
        }
    }


    render() {
        const rowLabel = `${this.store.collectionType} Receivables`;
        return (
            <Card>
                <Row gutter={16}>
                    <Col span={4} style={{paddingLeft: '30px'}}>
                        <Statistic title={rowLabel.toUpperCase()} value={this.store.rowCount} />
                    </Col>
                    <Col span={4} style={{textAlign:"right"}}>
                        <Statistic title="Total Bill" value={this.store.totalReceivable} />
                    </Col>
                    <Col span={5} style={{textAlign:"right"}}>
                        <Statistic title="Received" value={this.store.totalReceived} />
                    </Col>
                    <Col span={5} style={{textAlign:"right"}}>
                        <Statistic title="Due" value={this.store.due}/>
                    </Col>
                   
                </Row>
            </Card>
        )
    }
}

export default observer(LabDetailsSummary)
